import { Link } from "react-router-dom";
import { IconWrapper, Typography } from "@/components/ui/atoms";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { MetaBar } from "./MetaBar";
import type { BlogPostViewModel } from "../../types";

interface ArticleHeaderProps {
  post: BlogPostViewModel;
}

export function ArticleHeader({ post }: ArticleHeaderProps) {
  return (
    <header className="space-y-4 px-5 py-4 md:px-8">
      <Link
        to="/blog"
        className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.12em] text-dark-invirtus/60 transition-colors hover:text-dark-invirtus focus:outline-none focus-visible:underline"
      >
        <IconWrapper size="sm" color="primary">
          <ArrowLeftIcon />
        </IconWrapper>
        Back to blog
      </Link>
      <div className="space-y-2">
        <Typography
          as="h1"
          variant="h1"
          color="primary"
          weight="bold"
          className="text-2xl leading-tight tracking-tight md:text-[2rem]"
        >
          {post.title}
        </Typography>
        {post.excerpt ? (
          <Typography
            as="p"
            variant="body-md"
            color="secondary"
            className="text-base font-normal leading-[1.6]"
          >
            {post.excerpt}
          </Typography>
        ) : null}
      </div>

      <MetaBar
        publishedAt={post.publishedAt}
        createdAt={post.createdAt}
        tags={post.tags}
        author={post.author}
      />
    </header>
  );
}
